module.exports = __webpack_public_path__ + "img/1.57455696.jpg";